export interface MobileNumberAcknowledgement {
    [key: string]: number;
}

export enum UpdateMobileNumber {
    PopupIdentifier = 'update-mobile-number',
    StorageItemIdentifier = 'mobile-number-notification',
}
export interface ButtonClickEventData {
    details: string;
    url?: string;
}
